import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchUserProfile } from "../services/userService";

// Async thunk to fetch profile data
export const fetchProfile = createAsyncThunk("profile/fetch", async () => {
  const response = await fetchUserProfile();
  return response;
});

const profileSlice = createSlice({
  name: "profile",
  initialState: {
    data: null,
    status: "idle",
    error: null,
  },
  reducers: {
    clearProfile: (state) => {
      state.data = null;
      state.status = "idle";
      state.error = null;
    },

    // 🔥 used to update profile after editing
    patchProfile(state, action) {
      state.data = {
        ...state.data,
        ...action.payload,
      };
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(fetchProfile.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchProfile.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = action.payload;
      })
      .addCase(fetchProfile.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });
  },
});

// ❗ missing export in your version
export const { clearProfile, patchProfile } = profileSlice.actions;

export default profileSlice.reducer;